import { BaseExceptionApi } from '@/data/exceptions/BaseExceptionApi'

/**
 * 403, 또는 artist-aggregator 가 다운스트림 403 을 500 으로 감싼 응답
 * (`{"fail":{"status":500,"code":"INTERNAL_SERVER_ERROR","message":"Forbidden"}}`).
 * 권한 부족과 무효 토큰을 구분할 수 없으므로 전역 로그아웃 트리거로 쓰지 않고,
 * 사용자 식별 호출(authStore.getUserInfo)에서만 토큰 거부로 해석한다 (WP-6337).
 */
export class ExceptionApiForbidden extends BaseExceptionApi {
  constructor(message = 'Forbidden') {
    super('ExceptionApiForbidden', 'FORBIDDEN', message)
  }
}
